import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Paginator from '../common/Paginator';
import AssignmentsCardPlaceholder from './AssignmentsCardPlaceholder';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import AssignmentsChipList from './assignmentsChipList/AssignmentsChipList';
import { EmptyListPlaceholder } from '../common/EmptyListPlaceholder/EmptyListPlaceholder';

export class AssignmentsContent extends React.Component {
  constructor(props) {
    super(props);
    this.tasksToRender = this.tasksToRender.bind(this);
  }

  renderEmptyAssignments() {
    const { handleOpenCreateTaskModal, role, classroomId } = this.props;

    return (
      <EmptyListPlaceholder
        manageButtonClick={handleOpenCreateTaskModal}
        buttonLabel={'common.option.createTask'}
        label={'tasks.noTasks'}
        role={role}
        hiddenButton={() => this.hideTaskButton()}
      />
    );
  }

  hideTaskButton() {
    const { classroomId, assignmentButton } = this.props;
    if (classroomId) {
      return assignmentButton ? false : true;
    }
    return !classroomId;
  }

  tasksToRender(tasks) {
    const { currentPage, tasksPages, handlePageClick } = this.props;

    if (tasks.length === 0) {
      return this.renderEmptyAssignments();
    }
    const paginatorConfig = {
      page: currentPage,
      total: tasksPages
    };

    return (
      <div className="assignment-card-width">
        <CSSTransitionGroup
          transitionName="init"
          transitionAppear={true}
          transitionAppearTimeout={900}
          transitionEnter={false}
          transitionLeave={false}
        >
          {tasks}
        </CSSTransitionGroup>
        <Paginator paginator={paginatorConfig} handlePageClick={handlePageClick} />
      </div>
    );
  }

  render() {
    const { tasks, isFetching } = this.props;

    return (
      <div className={`assignments ${tasks.length ? '' : 'placeholder'}`}>
        <AssignmentsChipList />
        {isFetching ? <AssignmentsCardPlaceholder /> : this.tasksToRender(tasks)}
      </div>
    );
  }
}

AssignmentsContent.propTypes = {
  tasks: PropTypes.array,
  paginatorConfig: PropTypes.object,
  handlePageClick: PropTypes.func,
  currentPage: PropTypes.number,
  tasksPages: PropTypes.number,
  isFetching: PropTypes.bool,
  handleOpenCreateTaskModal: PropTypes.func,
  role: PropTypes.string,
  classroomId: PropTypes.string,
  assignmentButton: PropTypes.bool
};

function mapStateToProps(state) {
  return {
    assignmentButton: state.account.configuration.assignmentButton
  };
}

export default connect(mapStateToProps)(AssignmentsContent);
